export const INCIDENT_TYPE_LEGACY_VALUES = [
  "Unknown",
  "Repair",
  "TrailerRepair",
  "TrailerRepairs",
] as const;

export const INCIDENT_TYPE_MIGRATED_VALUE = "New";

export const normalizeIncidentTypeValue = (incidentType?: string | null) => {
  if (!incidentType) return incidentType;

  return INCIDENT_TYPE_LEGACY_VALUES.includes(
    incidentType as (typeof INCIDENT_TYPE_LEGACY_VALUES)[number],
  )
    ? INCIDENT_TYPE_MIGRATED_VALUE
    : incidentType;
};

export const IncidentType = [
  { value: "", label: "Select Incident Type" },
  { value: "New", label: "New" },
  { value: "RoadAssist", label: "Road Assist" },
  { value: "TireService", label: "Tire Service (repair)" },
  { value: "PmService", label: "PM Service" },
  { value: "DotInspection", label: "DOT Inspection" },
  { value: "Inspection", label: "Inspection" },
  { value: "PartPurchase", label: "Part Purchase" },
  { value: "Brakes", label: "Brakes" },
  { value: "TiresAndWheels", label: "Tires & Wheels (replacement)" },
  { value: "EngineAndPowertrain", label: "Engine & Powertrain" },
  { value: "SuspensionAndSteering", label: "Suspension & Steering" },
  { value: "Suspension", label: "Suspension" },
  { value: "Electrical", label: "Electrical" },
  { value: "BodyAndExterior", label: "Body & Exterior" },
  { value: "AirSystem", label: "Air System" },
  { value: "Transmission", label: "Transmission" },
  { value: "BodyWorkAfterCollision", label: "Body Work after Collision" },
  { value: "AxleAndDrivetrain", label: "Axle & Drivetrain" },
  { value: "HvacAndClimate", label: "HVAC & Climate" },
  { value: "TruckConsumables", label: "Truck Consumables" },
  { value: "TrailerConsumables", label: "Trailer Consumables" },
  { value: "Miscellaneous", label: "Miscellaneous" },
  { value: "Towing", label: "Towing" },
  { value: "Welding", label: "Welding" },
];

export const TruckIncidentType = IncidentType.filter(({ value }) =>
  [
    "",
    "New",
    "RoadAssist",
    "TireService",
    "PmService",
    "DotInspection",
    "PartPurchase",
    "Brakes",
    "TiresAndWheels",
    "EngineAndPowertrain",
    "SuspensionAndSteering",
    "Electrical",
    "BodyAndExterior",
    "AirSystem",
    "Transmission",
    "BodyWorkAfterCollision",
    "AxleAndDrivetrain",
    "HvacAndClimate",
    "TruckConsumables",
    "Miscellaneous",
    "Towing",
    "Welding",
  ].includes(value),
);

export const TrailerIncidentType = IncidentType.filter(({ value }) =>
  [
    "",
    "New",
    "RoadAssist",
    "TireService",
    "PmService",
    "DotInspection",
    "Inspection",
    "PartPurchase",
    "Brakes",
    "TiresAndWheels",
    "EngineAndPowertrain",
    "Suspension",
    "Electrical",
    "BodyAndExterior",
    "AirSystem",
    "BodyWorkAfterCollision",
    "AxleAndDrivetrain",
    "TrailerConsumables",
    "Miscellaneous",
    "Towing",
    "Welding",
  ].includes(value),
);

export const getIncidentTypesForAsset = (assetType?: string | null) => {
  if (assetType?.toLowerCase() === "trailer") return TrailerIncidentType;
  return TruckIncidentType;
};

export const normalizeIncidentTypeForAsset = (
  incidentType?: string | null,
  assetType?: string | null,
) => {
  if (!incidentType) return "";

  return (
    getIncidentTypesForAsset(assetType).find(
      ({ value }) => value.toLowerCase() === incidentType.toLowerCase(),
    )?.value ?? incidentType
  );
};

export const INCIDENT_TYPE_LABEL_MAP = IncidentType.reduce<
  Record<string, string>
>((acc, incidentType) => {
  if (incidentType.value) acc[incidentType.value] = incidentType.label;
  return acc;
}, {});

INCIDENT_TYPE_LEGACY_VALUES.forEach((legacyValue) => {
  INCIDENT_TYPE_LABEL_MAP[legacyValue] = "New";
});
